<template>
  <div class="text-center">
    <v-dialog
      @click:outside="setDialog()"
      @keydown.esc="setDialog()"
      v-model="dialog"
      width="650"
    >
      <v-card>
        <v-toolbar dark dense class="white--text" flat>
          <v-toolbar-title class="font-weight-regular my-4"
            >Leads seleccionados</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn icon @click="setDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <!-- Loading Data -->
        <div v-if="loading" class="text-center">
          <v-progress-circular
            :size="50"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </div>

        <!-- Error view -->
        <div v-else-if="!leads.length">
          <div class="text-center">
            <p class="text-h4 text--primary">
              UPS!!!
            </p>
            <p class="gray-text">
              Hubo un error al buscar los leads, Intentelo de nuevo mas tarde
            </p>
          </div>
          <v-img
            class="mx-auto"
            lazy-src="https://res.cloudinary.com/capital28-investments/image/upload/v1640032741/Capital%2028/Common/no_result_lead.png"
            max-height="210"
            max-width="260"
            src="https://res.cloudinary.com/capital28-investments/image/upload/v1640032741/Capital%2028/Common/no_result_lead.png"
          >
          </v-img>
        </div>
        <!-- List View -->
        <v-card-text v-else>
          <v-list subheader>
            <ListLeadItem
              v-for="item in leads"
              :item="item"
              :key="item._id"
              @click="setActualLead(item._id)"
            />
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="setDialog()">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <lead-detail-modal
      ref="leadDetailModal"
      page="table"
      :dialog="showDetail"
      @setDialog="
        value => {
          showDetail = value;
        }
      "
    />
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
export default {
  name: "ListLeadsByReportDetail",
  components: {
    LeadDetailModal: () => import("@/components/lead/LeadDetailModal"),
    ListLeadItem: () => import("./ListLeadItem.vue")
  },
  props: {
    dialog: {
      type: Boolean,
      required: true
    },
    leads: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showDetail: false
    };
  },
  computed: {
    ...mapState({
      lead: state => state.leads.actualItem
    })
  },
  methods: {
    ...mapActions({
      fetchLead: "leads/fetchActualLead"
    }),
    ...mapMutations({
      setLoadingActualLead: "leads/setLoading"
    }),
    setDialog() {
      this.$emit("setDialog", false);
    },
    async setActualLead(leadId) {
      this.setLoadingActualLead(true);
      this.showDetail = true;

      await this.fetchLead(leadId);
      // Se hace este parseo para que cuando mute el lead, no cambie el secundario
      let data = JSON.parse(JSON.stringify(this.lead));
      this.$store.commit("leads/setSecondaryLead", data);
      this.setLoadingActualLead(false);
    }
  }
};
</script>

<style scoped>
.v-dialog > .v-card > .v-card__subtitle,
.v-dialog > .v-card > .v-card__text {
  padding: 0px;
}
.itemStyle:hover {
  background: #e0e0e0;
}
</style>
